import { render, staticRenderFns } from "./Extract.vue?vue&type=template&id=2c22976a&scoped=true"
import script from "./Extract.vue?vue&type=script&lang=js"
export * from "./Extract.vue?vue&type=script&lang=js"
import style0 from "./Extract.vue?vue&type=style&index=0&id=2c22976a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c22976a",
  null
  
)

export default component.exports